import { toKebabCase } from "@utils/stringFormatters";

/**
 * A Talk to us request applies to the selected model, not an individual
 * variant. Keeping this key model-scoped prevents repeated intent collection
 * while a user moves between the MM page and any of that model's MMV pages.
 */
export const getAppTalkToUsSessionKey = (
  brandName?: string,
  modelName?: string,
) =>
  `talk_to_us_callback:${toKebabCase(
    [brandName, modelName].filter(Boolean).join(" "),
  )}`;

export const hasAppTalkToUsCallback = (sessionKey: string): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.sessionStorage.getItem(sessionKey) === "true";
  } catch {
    // A restricted WebView/session storage should not block the callback flow.
    return false;
  }
};

export const saveAppTalkToUsCallback = (sessionKey: string): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    window.sessionStorage.setItem(sessionKey, "true");
    return true;
  } catch {
    // Persistence is best-effort; the current callback can still complete.
    return false;
  }
};
